const footerRu = {
  'date': {
    'format': 'дд.мм.гггг',
  },
};

export default footerRu;
